<template>
	<div
		ref="div"
		:style="{width: itemWidth + 'px', height: itemHeight + 'px', left: left + 'px', top: top + 'px'}"
		class="ys-float-btn">
		<el-button
			v-if="loading"
			:disabled="loading"
			:loading="loading"
			:style="{width: itemWidth + 'px', height: itemHeight + 'px'}"
			circle
			plain
			type="primary"
			@click="onBtnClicked"></el-button>
		<el-button
			v-else
			:disabled="loading"
			:loading="loading"
			:style="{width: itemWidth + 'px', height: itemHeight + 'px'}"
			circle
			plain
			type="primary"
			@click="onBtnClicked">
			{{ text }}
		</el-button>
		<!-- <slot name="icon"></slot>
    <p>{{text}}</p> -->
	</div>
</template>

<script>
export default {
	name: 'FloatSaveBtn',
	props: {
		text: {
			type: String,
			default: '默认文字',
		},
		itemWidth: {
			type: Number,
			default: 60,
		},
		itemHeight: {
			type: Number,
			default: 60,
		},
		gapWidth: {
			type: Number,
			default: 10,
		},
		coefficientHeight: {
			type: Number,
			default: 0.8,
		},
		loading: false,
	},
	created() {
		this.calSize()
	},
	mounted() {
		window.addEventListener('resize', this.calSize)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.calSize)
	},
	methods: {
		calSize() {
			this.clientWidth = document.documentElement.clientWidth
			this.clientHeight = document.documentElement.clientHeight
			this.left = this.clientWidth - this.itemWidth - this.gapWidth - 20
			this.top = this.clientHeight * this.coefficientHeight
		},
		onBtnClicked() {
			this.$emit('onFloatBtnClicked')
		},
	},
	data() {
		return {
			timer: null,
			currentTop: 0,
			clientWidth: 0,
			clientHeight: 0,
			left: 0,
			top: 0,
		}
	},
}
</script>

<style lang="less" scoped>
.ys-float-btn {
	// background:rgb(255,255,255);
	// box-shadow:0 2px 10px 0 rgba(0,0,0,0.1);
	border-radius: 50%;
	// color: #666666;
	z-index: 1999;
	transition: all 0.3s;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	position: fixed;
	bottom: 20vw;

	// img{
	//   width: 50%;
	//   height: 50%;
	//   object-fit: contain;
	//   margin-bottom: 3px;
	// }

	// p{
	//   font-size:7px;
	// }
}
</style>
